import * as apiService from './api-service';
import { getSteemConfig } from '../config';
import { getGlobalProperties, vestsToSteem } from './dsteem-service';

export async function getWitnesses(limit: number = 100): Promise<any[]> {
  try {
    const globalProperties = await getGlobalProperties();

    const response = await apiService.post({
      url: `${getSteemConfig()}`,
      body: {
        method: "condenser_api.get_witnesses_by_vote",
        id: 2,
        params: ["", limit]
      }
    });

    if (!response || response.error) {
        throw new Error(response?.error?.message || "Failed to fetch witnesses");
    }

    // Process witnesses to format their votes into M (Millions) 
    // and extract only the fields we need.
    const processedWitnesses = await Promise.all(response.map(async (w: any) => {
        const votesInSteem = await vestsToSteem(w.votes, globalProperties);
        const votesInM = (parseFloat(votesInSteem.toString()) / 1000000).toFixed(6);

        return {
            owner: w.owner,
            url: w.url,
            votes: w.votes, // raw vests
            approvalAmount: votesInM,
            missedBlocks: w.total_missed,
            feedPrice: w.sbd_exchange_rate.base,
            version: w.running_version,
            signingKey: w.signing_key,
            props: w.props
        };
    }));

    // Fetch account details to get reputation for all witnesses
    const ownerNames = processedWitnesses.map(w => w.owner);
    let accounts: any[] = [];
    try {
        const accountsResponse = await apiService.post({
            url: `${getSteemConfig()}`,
            body: {
                method: "condenser_api.get_accounts",
                id: 2,
                params: [ownerNames]
            }
        });
        if (accountsResponse && Array.isArray(accountsResponse)) {
            accounts = accountsResponse;
        }
    } catch (e) {
        console.error("Error fetching witness accounts:", e);
    }

    // Map reputation to witnesses
    const witnessesWithRep = processedWitnesses.map(w => {
        const account = accounts.find(a => a.name === w.owner);
        return {
            ...w,
            reputation: account ? account.reputation : 0
        };
    });

    // Assign ranks only to active witnesses
    let rankCounter = 0;
    const witnesses = witnessesWithRep.map((w: any) => {
        const isInactive = w.signingKey === "STM1111111111111111111111111111111114T1Anm";
        if (!isInactive) {
            rankCounter++;
        }
        return {
            ...w,
            rank: isInactive ? null : rankCounter
        };
    });

    return witnesses;
  } catch (error) {
    console.error("Error fetching witnesses:", error);
    throw error;
  }
}
